<template>
  <FormGroup :startsEnabled="!!initialValue || null" :scope="scope">
    <template v-slot="{ inputName, inputId, error }">
      <input
          :value="modelValue"
          @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
          type="text"
          :id="inputId"
          class="form-control"
          :class="{
            'input-changed': wasChanged,
            'is-invalid': error,
          }"
          :name="inputName"
          :placeholder="placeholder"
      >
    </template>
  </FormGroup>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "@/types";
import FormGroup from "@/components/backend/candidacy/form_builder/form_items/shared/FormGroup.vue";

export default defineComponent({
  name: "TextField",
  components: { FormGroup },
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    scope: {
      type: Array as PropType<string[]>,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  data({ modelValue }) {
    return {
      initialValue: modelValue,
    }
  },
  computed: {
    wasChanged() {
      return this.initialValue !== this.modelValue;
    }
  },
});
</script>
